import PouchDB from 'pouchdb';
import PouchErase from 'pouchdb-erase';
import PouchFind from 'pouchdb-find';
import { PouchdbFilterInterface } from '../interfaces/pouchdb-filter.interface';

export class LocalDb {

  db: PouchDB.Database = undefined;

  constructor(dbName: string) {
    PouchDB.plugin(PouchFind).plugin(PouchErase);
    this.db = new PouchDB(dbName);
  }

  async find(id: number) {
    if (!this.db) {
      throw new Error("Invalid database");
    }

    if (!id) {
      return undefined;
    }

    const { docs } = await this.db.find({
      selector: { id: { $eq: id } }
    })
    return docs[0]
  }

  async save(obj: any) {
    if (!this.db) {
      throw new Error("Invalid database");
    }

    const founded = await this.find(obj.id)

    if (founded == undefined) {
      obj.id = (!obj.id) ? new Date().getTime() : obj.id;
      obj._id = obj.id.toString();
      obj._rev = '';
    } else {
      obj._id = founded._id;
      obj._rev = founded._rev;
    }

    return await this.db.put(obj)
  }

  async remove(id) {
    if (!this.db) {
      throw new Error("Invalid database");
    }

    const founded = await this.db.find({
      selector: { id: { $eq: id } }
    })

    if (founded == undefined) {
      return
    }

    return await this.db.remove(founded.docs[0])
  }

  async getAll(sort?: string) {
    if (!this.db) {
      throw new Error("Invalid database");
    }
    const query = { selector: { id: { $gte: null } } }
    if (sort) {
      query['sort'] = [sort];
    }

    const { docs } = await this.db.find(query)
    return docs
  }

  async query(filter: PouchdbFilterInterface) {
    if (!this.db) {
      throw new Error("Invalid database");
    }

    let _selector: any = {
      selector: {
        id: { $gt: null }
      }
    }

    if (filter) {
      let id = {}, selector = {};
      id[filter.op] = filter.value
      selector[filter.field] = id
      _selector['selector'] = selector;
    }

    const result = await this.db.find(_selector)

    if (filter.sort_by) {
      return this.sort(result.docs, filter.sort_by)
    }
  }

  sort(objs, field) {
    return objs.sort(function (a, b) {
      if (typeof a[field] == 'string') {
        return a[field].localeCompare(b[field], undefined, { numeric: true, sensitivity: 'base' });
      }
      if (typeof a[field] == 'number') {
        return a[field] - b[field]
      }
    });
  }

}
